import React, { useState } from 'react'
import styled from 'styled-components'
import { Download } from 'src/assets'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { KycModal } from 'src/components/Global/Modal'
import { ModalPopup, NinPopup, PassportW } from './ModalPopup'
import { Link, useLocation } from 'react-router-dom'
const KYCWrapper = styled.div`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 88vh;
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  h6 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: 500;
    margin-top: -10px;
  }
  .each {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      display: flex;
      align-items: center;
    }
    p {
      cursor: pointer;
    }
  }
  .info {
    background: #e1f5fe;
    border-radius: 10px;
    margin-top: -20px;
    padding: 20px 20px;
  }
  h3 {
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.dark};
  }
  p {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.investColor};
    margin-right: 25px;
  }
  input {
    margin-top: -20px;
  }
  .amount {
    margin-top: 20px;
  }
  .confirm {
    margin-top: 20px;
  }
`
const KycSettings = () => {
  let location = useLocation()
  const [showModal, setShowModal] = useState(false)
  const [showModalTwo, setShowModalTwo] = useState(false)
  const [showModalThree, setShowModalThree] = useState(false)

  const openModal = () => {
    setShowModal((prev) => !prev)
  }
  const openModalTwo = () => {
    setShowModalTwo((prev) => !prev)
  }
  const openModalThree = () => {
    setShowModalThree((prev) => !prev)
  }
  return (
    <KYCWrapper>
      <div>
        <h1>KYC Settings</h1>
        <h6>
          Upload a Valid ID Image (Intl. passport, NIN, driver’s license, voters
          card)
        </h6>
        <div className="info">
          <div className="each">
            <h3>Driver’s Licence</h3>
            <div>
              <p onClick={openModal}>View Sample</p>
              <img src={Download} alt="download" />
            </div>
          </div>
          <div className="each">
            <h3>Intl. Passport</h3>
            <div>
              <p onClick={openModalThree}>View Sample</p>
              <img src={Download} alt="download" />
            </div>
          </div>
          <div className="each">
            <h3>NIN</h3>
            <div>
              <p onClick={openModalTwo}>View Sample</p>
              <img src={Download} alt="download" />
            </div>
          </div>
          <div className="each">
            <h3>Voter’s Card</h3>
            <div>
              <p>View Sample</p>
              <img src={Download} alt="download" />
            </div>
          </div>
        </div>
        <KycModal showModal={showModal} setShowModal={setShowModal}>
          <ModalPopup />
        </KycModal>
        <KycModal showModal={showModalTwo} setShowModal={setShowModalTwo}>
          <NinPopup />
        </KycModal>
        <KycModal showModal={showModalThree} setShowModal={setShowModalThree}>
          <PassportW />
        </KycModal>
        <div className="amount">
          <h6>State of Residence</h6>
          <QuicksaveInput type="text" name="Amount" placeholder="" />
        </div>
      </div>
      <div>
        <Link to={`/big/token-sent`} state={{ backgroundLocation: location }}>
          <ModalButton className="confirm">Update KYC</ModalButton>
        </Link>
      </div>
    </KYCWrapper>
  )
}
export { KycSettings }
